(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const form = root.querySelector('form');
    if (!form) return;

    const steps = [...root.querySelectorAll('[data-step]')];
    const progressWrap = root.querySelector('[data-progress-wrap]');
    const progressBar = root.querySelector('[data-progress-bar]');
    const progressText = root.querySelector('[data-progress-text]');
    const progressPercent = root.querySelector('[data-progress-percent]');
    let currentStep = 0;

    const activeStep = () => root.querySelector(`[data-step="${currentStep}"]`);

    const clearValidation = () => {
      root.querySelectorAll('[data-validation]').forEach((el) => {
        el.textContent = '';
      });
    };

    const showValidation = (message) => {
      const target = activeStep()?.querySelector('[data-validation]');
      if (target) target.textContent = message;
    };

    const checkedValues = (group) =>
      [...root.querySelectorAll(`[data-group="${group}"]:checked`)].map(
        (input) => input.value
      );

    const scrollToForm = () => {
      const top = root.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    };

    const showStep = (step, scroll = true) => {
      currentStep = Math.max(0, Math.min(step, steps.length - 1));

      steps.forEach((item) => {
        item.classList.toggle(
          'is-active',
          Number(item.dataset.step) === currentStep
        );
      });

      if (progressWrap) progressWrap.hidden = currentStep === 0;

      if (currentStep > 0) {
        const percent = Math.round((currentStep / 6) * 100);
        if (progressBar) progressBar.style.width = `${percent}%`;
        if (progressText) progressText.textContent = `${currentStep} / 6`;
        if (progressPercent) progressPercent.textContent = `%${percent}`;
      }

      clearValidation();
      if (scroll) scrollToForm();
    };

    const validateStep = () => {
      clearValidation();

      if (currentStep === 1) {
        const input = root.querySelector('[data-field="size"]');
        if (!input?.value.trim()) {
          showValidation('Lütfen halı ölçüsünü yazın.');
          input?.focus();
          return false;
        }
      }

      if (currentStep === 2 && checkedValues('colors').length === 0) {
        showValidation('Lütfen en az bir renk seçin.');
        return false;
      }

      if (currentStep === 3 && checkedValues('room').length === 0) {
        showValidation('Lütfen bir oda seçin.');
        return false;
      }

      if (currentStep === 4 && checkedValues('style').length === 0) {
        showValidation('Lütfen en az bir stil seçin.');
        return false;
      }

      if (currentStep === 5 && checkedValues('household').length === 0) {
        showValidation('Lütfen en az bir seçenek işaretleyin.');
        return false;
      }

      return true;
    };

    root.querySelectorAll('[data-next]').forEach((button) => {
      button.addEventListener('click', () => {
        if (validateStep()) showStep(currentStep + 1);
      });
    });

    root.querySelectorAll('[data-back]').forEach((button) => {
      button.addEventListener('click', () => showStep(currentStep - 1));
    });

    root.querySelectorAll('[data-group="household"]').forEach((input) => {
      input.addEventListener('change', () => {
        const all = [...root.querySelectorAll('[data-group="household"]')];
        const exclusive = root.querySelector(
          '[data-group="household"][data-exclusive]'
        );

        if (input.hasAttribute('data-exclusive') && input.checked) {
          all.forEach((item) => {
            if (item !== input) item.checked = false;
          });
        } else if (input.checked && exclusive) {
          exclusive.checked = false;
        }
      });
    });

    const setResult = (name, value) => {
      const field = root.querySelector(`[data-result="${name}"]`);
      if (field) field.value = value;
    };

    const prepareSubmission = () => {
      const size = root.querySelector('[data-field="size"]')?.value.trim() || '';
      const colors = checkedValues('colors').join(', ');
      const room = checkedValues('room').join(', ');
      const style = checkedValues('style').join(', ');
      const household = checkedValues('household').join(', ');
      const note = root.querySelector('[data-field="note"]')?.value.trim() || '';

      setResult('size', size);
      setResult('colors', colors);
      setResult('room', room);
      setResult('style', style);
      setResult('household', household);

      setResult(
        'body',
        [
          'ÜCRETSİZ TASARIM DANIŞMANLIĞI TALEBİ',
          '',
          `Halı ölçüsü: ${size}`,
          `Renk paleti: ${colors}`,
          `Oda: ${room}`,
          `Stil: ${style}`,
          `Evde bulunanlar: ${household}`,
          '',
          `Ek not: ${note || 'Belirtilmedi'}`
        ].join('\n')
      );
    };

    form.addEventListener('submit', (event) => {
      clearValidation();

      const name = root.querySelector('input[name="contact[name]"]');
      const phone = root.querySelector('input[name="contact[phone]"]');
      const privacy = root.querySelector('[data-privacy]');

      if (!name?.value.trim() || name.value.trim().length < 2) {
        event.preventDefault();
        showValidation('Lütfen adınızı ve soyadınızı girin.');
        name?.focus();
        return;
      }

      const digits = phone?.value.replace(/\D/g, '') || '';
      if (digits.length < 10) {
        event.preventDefault();
        showValidation('Lütfen geçerli bir telefon numarası girin.');
        phone?.focus();
        return;
      }

      if (!privacy?.checked) {
        event.preventDefault();
        showValidation('Devam etmek için iletişim iznini onaylayın.');
        return;
      }

      prepareSubmission();

      const submit = root.querySelector('[data-submit]');
      const submitText = root.querySelector('[data-submit-text]');
      if (submit) submit.disabled = true;
      if (submitText) submitText.textContent = 'Gönderiliyor...';
    });

    showStep(0, false);
  };

  const initAll = () => {
    document.querySelectorAll('[data-ruggi-consult]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();